<script>
import VsContainer from 'viralstyle-ui/src/VsContainer';
import { mapGetters } from 'vuex';

import clientMixins from 'utils/client-mixins';
import RequestPayoutInstructions from 'components/RequestPayoutInstructions';
import PaymentModals from './PaymentModals';
import DeductionsModal from './DeductionsModal';
import { ValueText } from 'domains/base/store/model';

export default {
  components: {
    VsContainer,
    RequestPayoutInstructions,
    PaymentModals,
    DeductionsModal,
  },
  mixins: [
    clientMixins,
  ],
  data: () => ({
    privileged: false,
    tabs: [
      new ValueText('settingsPayoutsCampaigns', 'Campaigns'),
      new ValueText('settingsPayoutsReferrals', 'Referrals'),
      new ValueText('settingsPayoutsAffiliate', 'Affiliate'),
      new ValueText('settingsPayoutsDeductions', 'Deductions'),
    ],
  }),
  computed: {
    ...mapGetters(['permissionViewPayouts']),
  },
  async created() {
    if (this.permissionViewPayouts) {
      this.privileged = true;

      if (this.canRequestPayout) {
        this.$store.dispatch('getPayoutTotals');
      }

      let q = this.$route.query;

      if (q.merchant_id && q.payer_id) {
        if (q.success === 'true') {
          await this.$store.dispatch('savePingpong', q);

          this.$router.replace({ name: this.$route.matched[3].name });
        } else {
          this.$store.commit('addNotification', q.error || 'PingPong register failed, please try again.');

          this.$router.replace({ name: this.$route.matched[3].name });
        }
      }
    } else {
      this.$router.replace('/');
    }
  },
  methods: {
    handleCloseDeductionsModal() {
      this.$store.commit('lockScroll', false);

      this.$store.commit('updateState', { object: this.$store.state.settings, property: 'currentPayoutDeductionsDetails', value: null });
    },
  },
};
</script>

<template lang='pug'>
.payouts(v-if='privileged')
  vs-container(
    v-if='canRequestPayout',
    hide-date,
    hide-search,
    button-hidden,
    :tabs='tabs',
    :active-tab='$route.matched[2].name',
    @change-tab='$router.push({ name: $event })',
  )
    .payouts__container
      router-view

    payment-modals
    deductions-modal(@close='handleCloseDeductionsModal')

  request-payout-instructions(v-else)
</template>

<style>
@import '~import/index';
@import '~styles/index';

.details {
  &__label {
    @extend %text-transform;
    @extend %full-width;
    display: block;
    font-size: $h6;
    line-height: $h5;
  }

  &__value {
    @extend %word-break;
    line-height: $h5;
  }

  &__heading {
    line-height: $h4;
  }

  &__size {
    @extend %text-center;
  }

  &__half-cell {
    @include mq(mf-md) {
      width: 50%;
    }
  }

  .accordion-content {
    padding: 0;
    background-color: $white;

    >.vs-table:not(:first-child) {
      margin-top: 1rem;
    }
  }
}

.payouts {
  &__container {
    margin: 0 .5rem 1rem;
  }
}
</style>
